import { defineMessages } from 'react-intl'

export const consentMessages = defineMessages({
  saveError: {
    defaultMessage: 'Your choices could not be saved. Please allow site cookies and try again.',
    id: 'crUAi5v6dyPgNLcRBm0U',
  },
  continueNecessary: {
    defaultMessage: 'Continue without optional cookies',
    id: '_npG6O1uUabJxhorA8lD',
  },
  dialogLabel: {
    id: 'P0ir3RTrAJzOUMg1Gauo',
    defaultMessage: 'Cookie settings',
  },
  heading: {
    id: '5a2ZHhtv0iN9RmgfYVKR',
    defaultMessage: 'Your privacy, your choice',
  },
  responsibleParty: {
    id: 'XyMdQXAXDjhELSsdLd3c',
    defaultMessage: 'Luxury Escapes Travel Pty Ltd ACN 150 650 927 is responsible for your personal data on this site. We use necessary cookies and similar technologies to keep the site secure and working.',
  },
  optionalUse: {
    id: 'zblSHy8PwrID14HdDz3N',
    defaultMessage: 'With your permission, we and our partners use optional cookies to understand site performance, personalise your experience, test improvements and measure advertising.',
  },
  changeOrWithdraw: {
    id: 'Uvygt0907-yuIFPEeynS',
    defaultMessage: 'You can choose what works for you. You can change or withdraw your choices at any time in Cookie settings.',
  },
  cookiePolicy: {
    id: 'bgdXDtinCKL4C-LO6J_9',
    defaultMessage: 'Cookie Policy',
  },
  cookieSettings: {
    id: 'H6ZDMrjRdRRkZC4TluoJ',
    defaultMessage: 'Cookie settings',
  },
  necessaryTitle: {
    id: 'Bn35m0ETZ8bM2CKwy3Ub',
    defaultMessage: 'Necessary cookies',
  },
  necessaryDescription: {
    id: 'sbo9gBTgEz8S6C_652vy',
    defaultMessage: 'Always on. Keep the site secure, remember your session and enable features such as signing in and saving your cart.',
  },
  analytics: {
    id: 'NgBJ-vEdvNXc8-c0_h-Z',
    defaultMessage: 'Analytics',
  },
  analyticsDescription: {
    id: 'yBn8nIhWVUfoU50tqOPN',
    defaultMessage: 'Help us understand how the site performs and improve it.',
  },
  personalisation: {
    id: 'bPJ2lWFlstztDo4dBchO',
    defaultMessage: 'Personalisation',
  },
  personalisationDescription: {
    id: '0XjPzXUJ5XEA1GYK4kl3',
    defaultMessage: 'Use your activity and preferences to make the content you see more relevant.',
  },
  experimentation: {
    id: 'aAcXE1FJL-N4LO4BNijm',
    defaultMessage: 'Experimentation',
  },
  experimentationDescription: {
    id: 'smZhttAj-I2HX9568uUZ',
    defaultMessage: 'Together with analytics, help us test improvements to the site experience. Both choices must be enabled to take part.',
  },
  advertising: {
    id: 'dMOeQha5cjaSOJintIMS',
    defaultMessage: 'Advertising',
  },
  advertisingDescription: {
    id: 'eLQUMQXn-tNy_q6Ae5nx',
    defaultMessage: 'Allow us and our advertising partners to measure our advertising and show you more relevant ads on other sites and apps. This involves sharing data with those partners.',
  },
  acceptAll: {
    id: 'z575AVqSBQMz6zYMIc8Y',
    defaultMessage: 'Accept all',
  },
  necessaryOnly: {
    id: 'ASN-kKqGksaxH6K_qfn_',
    defaultMessage: 'Necessary cookies only',
  },
  configure: {
    id: 'Uie2oPdgbN0aXegfplEp',
    defaultMessage: 'Configure',
  },
  saveChoices: {
    id: 'glsHGujAkFmSyssn5ykC',
    defaultMessage: 'Save choices',
  },
  savedConfirmation: {
    id: 'GHyB357odJS3RVoko8mM',
    defaultMessage: 'Your cookie choices have been saved. You can review or change them at any time in Cookie settings.',
  },
  gotIt: {
    id: 'pHYwqWFUczaYcjf3MS5r',
    defaultMessage: 'Got it',
  },
  applyingChoices: {
    id: 'rpPDnbBmboFvECyMMAWW',
    defaultMessage: 'Applying your cookie choices',
  },
})
